'use strict';

angular
    .module('directives.selfAccessRequestDecision')
    .controller('selfAccessRequestDecisionListController', ['$scope', '$state', '$stateParams', 'selfAccessRequestService', function ($scope, $state, $stateParams, selfAccessRequestService) {

        $scope.systemList = $scope.model.SystemList;

        var selectAllDecision;
        var unSelectAllDecision;

        // Load Decisions Add and Reject
        selfAccessRequestService.getSelfAccessRequestLookups()
            .then(function (progressStepDecisions) {
                selectAllDecision = _.find(progressStepDecisions.ProgressStepDecisions, {
                    SelfAccessRequestProcessStepID: $scope.processStepId,
                    ValidForSelection: 'SelectAll'
                });

                unSelectAllDecision = _.find(progressStepDecisions.ProgressStepDecisions, {
                    SelfAccessRequestProcessStepID: $scope.processStepId,
                    ValidForSelection: 'UnSelectAll'
                });
            });

        // Go Back
        $scope.goBack = function () {
            $state.go('event', { eventGroupId: null }, { reload: true });
        };

        // Select all decision roles
        $scope.selectAll = function () {
            if ($scope.disabled)  return;
            if (_.isUndefined(selectAllDecision)) return;

            var decisionsToUpdate = [];
            _.forEach($scope.systemList, function (system) {
                _.forEach(system.UserSystemRoleDecisionList, function (decision) {
                    decision.Decision = selectAllDecision;
                    decision.SelfAccessRequestProcessStepDecisionID = selectAllDecision.SelfAccessRequestProcessStepDecisionID;
                    decisionsToUpdate.push(decision);
                });
            });

            selfAccessRequestService.updateAllUserSystemRoleDecisions($stateParams.userAccessRequestId,
                                                                      decisionsToUpdate);
        }

        // UnSelect all decision roles
        $scope.unSelectAll = function (system) {
            if ($scope.disabled)  return;
            if (_.isUndefined(unSelectAllDecision)) return;

            var decisionsToUpdate = [];
            _.forEach($scope.systemList, function (system) {
                _.forEach(system.UserSystemRoleDecisionList, function (decision) {
                    decision.Decision = unSelectAllDecision;
                    decision.SelfAccessRequestProcessStepDecisionID = unSelectAllDecision.SelfAccessRequestProcessStepDecisionID;
                    decisionsToUpdate.push(decision);
                });
            });

            selfAccessRequestService.updateAllUserSystemRoleDecisions($stateParams.userAccessRequestId,
                                                                      decisionsToUpdate);
        }

    }]);